{
  "RESET_PASSWORD": {
    "TITLE": "Parola yenile",
    "DESCRIPTION": "Şifrenizi sıfırlamak için Chatwoot'ta oturum açmak için kullandığınız e-posta adresini girin.",
    "GO_BACK_TO_LOGIN": "Giriş sayfasına geri dönmek istiyorsanız,",
    "EMAIL": {
      "LABEL": "E-Posta",
      "PLACEHOLDER": "Lütfen E-postanızı girin.",
      "ERROR": "lütfen geçerli e-posta adresini giriniz."
    },
    "API": {
      "SUCCESS_MESSAGE": "E-postanıza parola sıfırlama bağlantısı gönderildi.",
      "ERROR_MESSAGE": "Woot sunucusuna bağlanılamadı. Lütfen tekrar deneyin."
    },
    "SUBMIT": "Yolla"
  }
}
